import { getPromotionalUrl } from '../../../../helpers/helpersIndex';
import { IKIOSKModel } from '../../../../models/kioskModel2';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
let timer;

const PromotionalSlides: React.FC = () => {
    const promotionalImagesData: any = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.promotionalData);
    const mediaItems = promotionalImagesData?.map((a) => ({ src: getPromotionalUrl()?.endsWith('/') ? `${getPromotionalUrl()}${a}` : `${getPromotionalUrl()}/${a}` , type: a?.split('.').pop() }));
    const filtergedmediaitems=mediaItems?.filter((x)=>['jpg','png','gif','jpeg','mp4'].includes(x?.type))
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentItem = filtergedmediaitems?.[currentIndex];
    useEffect(() => {
        const currentItem = filtergedmediaitems?.[currentIndex];
        if (currentItem?.type === 'jpg' || currentItem?.type === 'png' || currentItem?.type === 'gif' || currentItem?.type === 'jpeg') {
            timer = setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % filtergedmediaitems.length);
            }, 5000);
        }
        return () => {
            clearTimeout(timer);
        }
    }, [currentIndex,filtergedmediaitems]);
    const handleVideoEnded = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % filtergedmediaitems?.length);
    };
    return (
        <div className='kiosk_preview_slides'>
            {currentItem?.type === 'mp4' ? (
                <video width="750" muted
                    autoPlay
                    onEndedCapture={handleVideoEnded}
                    src={currentItem?.src}
                ></video>
            )
                : (
                    <img
                        src={currentItem?.src}
                        alt="slideshow"
                        width="600"
                    />
                )}
        </div>
    )
}
export default React.memo(PromotionalSlides);